import styled from "styled-components";

export const ContentTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  font-size: 1rem;
  user-select: none;

  .title {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    flex-shrink: 0;
  }
  .click-bar {
    height: 30px;
    width: 70%;
    cursor: pointer;
  }
  .end-buttons {
    display: flex;
    align-items: center;
    gap: 0.2rem;
  }

  .add-button {
    cursor: pointer;
    border: none;
    background: none;
  }
`;
